// Default page after login: Students (/users) when the user can open it, else their first accessible page.
export const DEFAULT_LANDING_PAGE = '/users';

export function landingPage(accessPages) {
  const pages = Array.isArray(accessPages) ? accessPages : [];
  return pages.includes(DEFAULT_LANDING_PAGE) ? DEFAULT_LANDING_PAGE : pages[0];
}
